import { useNavigate } from "react-router-dom";

const useErrorPage = () => {
    const navigate = useNavigate();

    const toErrorPage = (error: any) => {
        if(error.response.status === 401) {
            localStorage.removeItem("admin");
            localStorage.removeItem("token");
            navigate('/admin/login');                        
        }
        else {
            navigate('/error', { state: { error: error.message }});
        }
    }
    
    return [toErrorPage];
};

export default useErrorPage;